import { styled } from "../../../styled-components";

export const ChipsViewStyle = styled.div`
    > * + * {
        --tw-space-y-reverse: 0;
        margin-left: calc(0.1rem * calc(1 - var(--tw-space-y-reverse)));
        margin-right: calc(0.1rem * var(--tw-space-y-reverse));
    }
`;

export const ItemWrapper = styled.div`
    display: inline-block;
    position: relative;
    margin: 0 4px 4px 0;
    padding: 8px 16px;
    color: ${p => p.theme.fgColorDark};
    background-color: ${p => p.theme.picker.backgroundColor};

    cursor: pointer;

    .display-item {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    &.current .display-item {
        color: ${p => p.theme.accentForegroundColor};
        background-color: ${p => p.theme.primaryAccentColor};
        font-weight: 600;
    }

    .size-item {
        opacity: 0;
        font-weight: 600;
    }

    border-radius: 100px;
    overflow: hidden;

    ${p => p.theme.fontStyles.Body4}
`;
